import { wsService } from "./wsService";
import axios from "axios";

const section = "storage";
const api_url = process.env.VUE_APP_API_URL;

function downloadFile(filename, accept = "application/pdf", responseType = "arraybuffer") {
  //return wsService.make_get_request(section + filename,0,'application/pdf','arraybuffer');
  const token = localStorage.getItem("token");  
  return axios
      .get(api_url+section+filename, {
          responseType: responseType,
          headers: {
              'Accept': accept,
              "Content-Type": "application/json; charset=utf-8",
              'Authorization': "Bearer " + token,
          }
      })
}

function downloadOVHFile(url, accept = "application/pdf", responseType = "arraybuffer") {
  //return wsService.make_get_request(section + filename,0,'application/pdf','arraybuffer');  
  return axios
      .get(url, {
          responseType: responseType   ,
          headers: {            
            "Access-Control-Allow-Origin": "*"//storage.bhs.cloud.ovh.net
          }       
      })
}

function getFileUrl(filename) {
  return api_url+section+filename;      
}

export const filesService = {
  section,
  downloadFile,
  downloadOVHFile,
  getFileUrl,
};
